Object.defineProperty(exports, "__esModule", {
  value: true
});

exports['default'] = function (_ref) {
  var propType = _ref.propType,
      restrictedCondition = _ref.restrictedCondition,
      restrictedMessage = _ref.restrictedMessage;

  return function () {
    function conditionallyRestrictedProp(props, propName, componentName) {
      for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        rest[_key - 3] = arguments[_key];
      }

      if (restrictedCondition(props, propName)) {
        return (0, _airbnbPropTypes.restrictedProp)(restrictedMessage).apply(undefined, [props, propName, componentName].concat(rest));
      }
      return propType.apply(undefined, [props, propName, componentName].concat(rest));
    }

    return conditionallyRestrictedProp;
  }();
};

var _airbnbPropTypes = require('airbnb-prop-types');


//////////////////
// WEBPACK FOOTER
// ./~/airbnb-dls-web/build/utils/propTypes/conditionallyRestrictedProp.js
// module id = 157
// module chunks = 168707334958949